import { createContext } from 'preact';
const ScrollContext = createContext({});
export default ScrollContext;
//# sourceMappingURL=ScrollContext.js.map